<script>
    import { _ } from "../services/i18n";
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    export let accept = "";
    export let id = "";
    export let name = "";
    export let required = false;

    function onChange(evt) {
        dispatch('change', evt.target.files);
    }

</script>

<input type="file" id={id} name={name} accept={accept} on:change={onChange} required={required} />